import React from 'react';

const AboutPage = () => {
  return (
    <div className="md:px-24 px-4 md:mb-20 mb-10 mt-10  md:mt-20">
      {/* Icon */}
      <img 
        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745858904/Expand_left_dshlo0.png" 
        alt="Expand Icon" 
        className="md:w-6 md:h-6 h-3 w-3  mb-6"
      />

      {/* Text */}
      <div className="md:text-[36px] text-[8px] leading-relaxed font-normal text-black md:mt-20">
        <p>
          Ad-Luck is a South African consultancy and advisory firm committed to empowering entrepreneurs and building sustainable <br/>enterprises.
        </p>
        <p>
          We specialise in training and development programmes that support small businesses and cooperatives across high-impact sectors including Agriculture, Renewable Energy, and Waste Management. Through our hands-on approach, sector expertise, and strategic partnerships, we help entrepreneurs unlock opportunities, access resources, and grow resilient, future-fit businesses that contribute meaningfully to South Africa’s economy and green transition.
        </p>
      </div>
      <div className='md:h-80 h-40'></div>
    </div>
  );
};

export default AboutPage;
